/*********************************************
Translation example:
  button: {
    search: 'Search'
  },
==>
  button: {
    search: '検索'
  },
*********************************************/
 export default {
  payingText: '支払う...',

  general: {
    change: '変更',
    save: '決定',
    cancel: 'キャンセル',
    or: 'または',
    privacyPolicy: 'プライバシーポリシー',
    privacyPolicyLink: 'https://www.clickdishes.jp/privacy-policy',
    termsOfUse: '利用規約',
    termsOfUseLink: 'https://www.clickdishes.jp/term',
    restaurants: '加盟店募集',
    restaurantsLink: 'https://www.clickdishes.jp/partners',
    facebookLink: 'https://www.facebook.com/ClickDishesJP/',
    twitterLink: 'https://twitter.com/ClickDishes_jp',
    instagramLink: 'https://www.instagram.com/ClickDishes_jp/',
    agreeButtonText: '同意する',
    serverError: '申し訳ありませんがサーバーがエラーしました',
    signin: 'サインイン',
    confirm: {
      soloOrder: '一人で注文しますか？'
    },
    success: {
      orderSent: '注文が無事に発信されました。'
    },
    error: {
      permissionNotAllowed:
        'すみません、このリソースにはアクセスできません。',
      nameOnCard: 'カードの名前を入力してください。',
      convertToSoloOrder: 'すみません、一人の注文に変えることができ'
    },

    filterText: 'フィルター',
    specialRequest: 'スペシャルリクエスト',
    orderNumber: '注文番号 #',
    okText: 'OK',
    email: 'メールアドレス',
    ptsText: 'ポイント',
    address: '{city}{streetName}{streetNumber}'
  },
  page: {
    copyright: '著作権',
    company: 'ClickDishes',
    rightsReserved: 'All rights reserved.'
  },
  header: {
    signinText: 'サインイン',
    signupText: '新規登録',
    signoutText: 'サインアウト',
    accountMenu: {
      updateAccount: 'アカウントをアップデート',
      orderHistory: '注文履歴',
      rewards: 'リワード',
      inviteFriends: '友達を誘う',
      friends: '友達',
      paymentMethods: 'お支払い方法',
      accountText: 'アカウント',
      help: 'ヘルプ',
      helpUrl: 'https://www.clickdishes.jp/faq',
      signout: {
        confirmText: '現在の注文をキャンセルしますか？'
      }
    },

    changeLocation: {
      tooltip: '位置情報を変更する'
    },

    search: {
      tooltip: '店舗名で検索する',
      closeButtonText: '閉じる',
      placeholder: '店舗名で検索する'
    }
  },
  spinner: {
    text: '読み込み中...'
  },

  showMore: {
    buttonText: 'さらに表示する'
  },

  confirm: {
    yesButtonText: 'はい',
    noButtonText: 'いいえ',
    titleText: '注文キャンセルする'
  },

  rating: {
    level45Text: '4.5以上',
    level40Text: '4.0以上',
    level35Text: '3.5以上',
    level30Text: '3.0以上'
  },
  signin: {
    title: 'サインイン',
    spinner: {
      text: 'サインイン'
    },
    email: {
      placeholder: 'メールアドレス',
      validation: 'メールアドレスを入力してください'
    },
    password: {
      placeholder: 'パスワード',
      validation: 'パスワードを入力してください'
    },

    signinText: 'サインイン',

    or: 'Or',
    forgetPassword: 'パスワードを忘れた',
    continueWithFacebook: 'Facebookで続ける',
    continueWithGoogle: 'Googleで続ける',
    failText: 'メールアドレスまたはパスワードが有効ではありません。',
    button: {
      signin: 'メールアドレスでサインインする'
    },
    successText: 'サインインできました。',
    social: {
      successText: 'サインインできました。',
      failText: 'サインインできませんでした。再度、お試しください。 '
    },
    error: {
      convertAnonymous: 'すみません、匿名の注文には変更できません。',
      google: 'Googleからの権限でエラーが起きました。',
      failText: 'メールアドレスまたはパスワードが有効ではありません。'
    }
  },

  signout: {
    successText: 'サインアウトできました。'
  },
  signup: {
    title: '新規登録',
    or: 'または',
    needAccount: '登録がまだの方はこちら？',
    signup: '新規登録',
    signUpWithEmail: 'メールアドレスで新規登録',
    signupConditionText1: 'アカウントを作って、私たちの規約に同意 ',
    signupConditionText2: ' と ',
    signupConditionText3: 'しますか。',
    signupWithFacebook: 'Facebookで新規登録',
    signupWithGoogle: 'Googleで新規登録',
    referralCode: {
      placeholder: '招待コード (任意)',
      invalidText: '招待コードが有効ではありません。'
    }
  },

  emailSignup: {
    title: '新規登録',
    or: 'Or',
    buttonText: '新規登録',
    cancelText: 'キャンセル',
    nextText: '次へ',
    email: {
      placeholder: 'メールアドレス',
      required: 'メールアドレスが必要です',
      invalid: 'メールアドレスが有効ではありません',
      isTaken: 'そのメールアドレスはすでに登録されています'
    },
    password: {
      placeholder: 'パスワード',
      required: 'パスワードを入力してください',
      minLength6: 'パスワードは6文字以上で設定してください'
    },
    confirmPassword: {
      placeholder: 'パスワードを再度入力してください',
      required: '認証のために再度パスワードを入力してください',
      minLength6: 'パスワードは6文字以上で設定してください'
    },
    firstName: {
      placeholder: '名前',
      required: '名前を入力してください'
    },
    lastName: {
      placeholder: '名字'
    },

    successText: '新規登録できました。',
    failText: 'すみません、新規登録できませんでした。',
    phoneNumberExists: 'その電話番号はすでに登録されています。',
    error: {
      passwordsNotMatched: 'パスワードと認証のために再度入力されたパスワードが一致しません。',
      emailExists: 'そのメールアドレスはすでに登録されています。'
    }
  },

  socialSignup: {
    title: '新規登録',
    buttonText: '新規登録',
    successText: '新規登録できました。',
    error: {
      signup: 'すみません、新規登録できませんでした。.'
    }
  },

  phoneNumberVerifier: {
    countryCode: '国名コード',
    placeholder: '電話番号',
    button: {
      sendCode: 'コードを送る',
      verify: 'Verify' //updated
    },
    sendCodeSuccess: {
      message: 'あなたの携帯に送られた5文字の識別コードを入力してください。.'
    },
    sendCodeFail: {
      message: 'コードが送られていません。'
    },
    verificationCode: {
      placeholder: '識別コード'
    }
  },

  forgotPassword: {
    titleText: 'パスワードを忘れた場合',
    hintText: 'パスワードをリセットするために、メールアドレスを入力してください。',
    buttonText: 'パスワードをリセットする',
    placeholder: {
      emailAddress: 'メールアドレス'
    },
    error: {
      emailInvalid: 'メールアドレスが有効ではありません。',
      resetFailed: 'パスワードをリセットできませんでした。'
    },
    success: {
      emailSent: 'パスワードをリセットするためのリンクがあなたのメールアドレスに送信されました。'
    }
  },

  resetPassword: {
    titleText: 'パスワードをリセットする。',
    buttonText: 'パスワードを変更する。',
    placeholder: {
      newPasswordText: '新しいパスワード',
      reenterPasswordText: '新しいパスワードを再入力する'
    },

    error: {
      passwordNotMatch: 'パスワードが一致しません。再度お試しください。',
      passwordLength6: 'パスワードは6文字以上で入力してください。',
      resetFailed: 'すみません、パスワードのリセットができませんでした。'
    },
    success: {
      passwordReset: 'パスワードのリセットができました。'
    }
  },

  home: {
    line1: '事前に注文して、待ち時間とはおさらばしよう。列に並ぶのはもうやめよう',
    line2: 'ClickDishesでテイクアウトしよう.',
    placeholder: '住所を入力する',
    getApp: 'アプリをダウンロードする:'
  },

  addressBar: {
    findFood: 'ご飯を探す',
    locationTrackingNotEnabled: '位置情報の追跡はできません。',
    locationTrackingNotAvailable: '位置情報の追跡はできません。',
    currentLocationText: '現在地',
    vancouverText: 'バンクーバー',
    calgaryText: 'カルガリー',
    edmontonText: 'エドモントン',
    marunouchiText: '丸の内',
    shinjukuText: '新宿',
    toranomonText: '虎ノ門',
    input: {
      placeholder: '住所を入力して、はじめよう'
    },
    geocode: {
      failText: 'すみません、ジオコーディングができませんでした。',
      errorText: '住所が見つかりません。'
    },
    currentLocation: {
      tooltip: '現在位置を使う。',
      errorText: '現在の位置情報を得ることができません。'
    }
  },

  restaurants: {
    tooltip: {
      favorite: 'Toggle favorite' //missed?
    },
    directionButtonText: '経路',
    minsText: '分',
    filters: {
      buttonText: 'フィルタ'
    },
    sorter: {
      buttonText: '並べ替えする'
    },
    nextOpenTime: {
      closedText: '閉店',
      opensAtText: '{dayTime} に開店'
    },
    errors: {
      cuisinesError: 'ご飯の受け取りに失敗しました。',
      currentLocation: 'すみません、現在の位置情報を'
    },
    notFound: "条件にマッチするお店が近くにないようです。",
    favorite: {
      clicked: '{restaurantName}をお気に入りに加えました！',
      canceled: '{restaurantName}をお気に入りから削除しました！',
      error: 'Sorry, can not change restaurant favorite.'
    }
  },

  filters: {
    button: {
      applyText: '絞り込み',
      cancelText: 'キャンセル'
    },
    cuisines: {
      titleText: '料理'
    },
    ratings: {
      titleText: ''
    },
    rewardsOnly: {
      titleText: 'ポイント割引',
      titleText2: 'ポイント割引対象店舗'
    },

    favoritesOnly: {
      titleText: 'お気に入り',
      titleText2: 'お気に入り店舗'
    }
  },

  sorter: {
    button: {
      applyText: '申し込む',
      cancelText: 'キャンセル'
    },
    list: {
      restaurantName: 'お店の名前',
      mostClosest: '最も近い',
      highestRating: '評価が高い',
      highestPrice: '最も高い',
      lowestPrice: '最も安い'
    }
  },
  restaurant: {
    header: {
      confirmOrderDelete: '本当に注文をキャンセルしますか？',
      rating: '評価:',
      ratingLink: 'このレストランを最初に評価する人になってみましょう。',
      info: {
        direction: '行き方',
        call: '電話',
        hours: '営業時間',
        closeButtonText: '閉じる'
      },
      estimations: '出来上がり目安：{estimations}分'
    },
    error: {
      deleteOrder: 'すみません、注文をキャンセルできません。',
      createOrder: 'すみません、注文できません',
      updateDish: 'すみません、この料理を更新することができません。',
      removeDish: 'すみません、この料理を注文リストから削除できません。',
      addDish: 'すみません、この料理を追加することができません。.'
    },
    menu: {
      soldOutText: '売り切れ',
      addButtonText: '追加する',
      addMoreButtonText: 'さらに追加する',
      saveXPointsWithYDolllarText: '{points}ポイントで{savings}割引'
    },
    cart: {
      subTotalText: '小計:',
      checkOutButtonText: '支払をする',
      cartIsEmptyText: '注文リストには何もありません。',
      cartEmptyReminderText: '今日は、どの料理を持ち帰ろう。',
      specialRequestText: 'スペシャルリクエスト:',
      orderExpiredText: 'The order has expired and the page will be updated soon.'
    },
    bottomCart: {
      viewOrderText: 'カートを見る'
    },
    signInReminder: {
      signInButtonText: 'サインイン',
      notSignInButtonText: 'ゲストとして続ける。',
      signInDescription:
        'サインインして、登録済のカードで素早く支払いを済ませよう。',
      signInDescription1: 'サインインして購入で、{subTotal}ポイント獲得。', 
      signInDescription2:
        'この注文の支払いを登録済のカードで素早く済ませよう。',

      nextButtonText: '次へ',
      cancelButtonText: 'キャンセル',
      placeholder: '名前を入力してください。（必須）',
      phoneNumberPlaceholder: '電話番号を入力してください。（必須）'
    },
    isBusyReminder: {
      isBusyText: '店舗が忙しいため、当店では注文をお受けできない可能性がございます。他のお店をお試しいただくか、ピーク時間の後のご注文をお勧めします。',
      isBusyButtonText: 'わかりました',
      isBusyTitleText: '申し訳ございません。'
    },
    isFoodTruckReminder: {
      isFoodTruckText: '本日、{restaurantname}は{address} にあります。',
      isFoodTruckText2: '{restaurantname}の店舗は、近くに複数あります。</br>これは{address} にあります。',
      isFoodTruckText3: '本日、{restaurantname}は{address} にあります。</br>このお店でご注文内容を受け取ることを承認してください。',
      isFoodTruckButtonText: 'わかりました',
      isFoodTruckButtonText2: '承認する',
      isFoodTruckTitleText: '受け取り場所'
    }
  },
  saveDish: {
    specialRequestInfo: '追加要望は、200文字以内でご記入ください。',
    specialRequest: 'スペシャルリクエストが届いたらここに入力してください。',
    noEnoughPoints: 'ポイントが足りません。',
    redeemableText: '最初の注文で交換可能',
    signedInUsersOnly: 'サインインしたユーザーしかご使用できません。',
    addToOrderButtonText: '注文に追加する',
    updateOrderButtonText: '注文を更新する',
    removeOrderButtonText: '商品を削除',
    cancelButtonText: 'キャンセル',
    signinLinkText: 'サインイン',
    soldOut: 'サインアウト',
    rewards: {
      error: {
        fetchPoints: 'すみません、リワードを使うことができません。'
      }
    }
  },

  checkBoxGroup: {
    minRequiredText: '必須',
    chooseUpToX:'Choose up to {maxLimit}',
    chooseAsManyAsYouWouldLike: 'Choose as many as you would like',
    chooseXtoYoptionsfor: 'Choose {minLimit} to {maxLimit} options for {categoryName}',
    chooseAtLeastXoptionsfor: 'Choose at least {minLimit} options for {categoryName}',
    chooseExactlyXoptionsfor: 'Choose exactly {maxLimit} options for {categoryName}'
  },
  radioButtonGroup: {
    requiredText: '必須'
  },
  checkout: {
    promoErrorText: 'すみません、プロモーションコードを取得できません。',
    promoIsUsedText: 'すみません、このプロモーションコードは使用済みです。',
    promoNotAvailableText: 'すみません、このプロモーションコードはご使用になれません。',
    promoExpiredText: 'すみません、プロモーションコードは有効期限切れです。',
    promoNotEligibleText:
      'すみません、合計金額が十分でないので、割引することができません。',
    payWithCreditCardText: 'クレジットカードで支払う',
    noItemInOrderText: '注文リストには何もありません。',
    backToMenuText: 'メニューに戻る',
    error: {
      fetchOrder: 'すみません、ご注文の料理を受け取って、お渡しすることができませんでした。',

      cancelOrder: 'すみません、注文をキャンセルできません。',
      updateDish: 'すみません、料理を更新することができません。',
      reorder: 'すみません、再注文することができません。',
      removeDish: 'すみません、この料理を注文リストから削除できません。'
    },
    dish: {
      specialRequestText: 'リクエスト:'
    },
    summary: {
      subtotalText: '小計:',
      taxText: '税金:',
      tipText: 'チップ:',
      discountText: '割引:',
      savingsText: '貯金:',
      totalText: '合計金額:',
      rewardsText: 'リワード:',
      pointsUsedText: 'ご使用ポイント:',
      showDetailsText: '詳細を表示',
      hideDetailsText: '詳細を隠す',
      pickupTimeText: '受け取り時刻：',
      cancelOrderButtonText: '注文をキャンセルするする',
      confirmCancelOrdereText: '本当に注文をキャンセルますか？'
    },
    tip: {
      applyButtonText: 'OK',
      cancelButtonText: 'キャンセル',
      addTipText: 'チップを追加する',
      tip0: 'チップなし',
      tip10: '10% チップ',
      tip15: '15% チップ',
      tip20: '20% ',
      other: 'その他'
    },
    pickupTime: {
      ASAP: "今すぐ注文",
    },
    promo: {
      applyingText: '申し込み中',
      applyButtonText: '申し込む',
      dismissButtonText: 'やめる',
      addPromoCodeText: 'プロモーションコードをお持ちですか？',
      offText: 'オフ',
      promoText: 'プロモーション',
      promoText2: '紹介リワード',
      placeholder: 'プロモーションコード',
      referralRewardApplied: '紹介リワードを使いました。',
      error: {
        notApplied: '紹介コードは使えません。',
        fetchReferalReward: 'すみません、参照コードは使えません。'
      },
      reminder: {
        cancelButtonText: 'いいえ、結構です。',
        signinLinkText: 'サインイン',
        signupLinkText: '新規登録',
        text: '今日、今すぐ、プロモーション割引をゲットしよう！'
      }
    },
    creditCard: {
      cancelButtonText: 'キャンセル'
    },
    quickPayButton: {
      applePayText: 'Apple Pay',
      googlePayText: 'Google Pay'
    },
    creditCardForm: {
      cardNameText: 'カード上の名前',
      cardNumberText: 'カード番号',
      expirationDateText: '有効期限',
      cvcText: 'CVC',
      postalCodeText: '郵便番号',
      postalCodeTextHint: '111-2345',
      makePaymentText: '支払い'
    },
    customTip: {
      applyButtonText: '使う',
      error: {
        greaterThan0: 'チップは必ず入れてください。',
        numeric: 'チップの額が十分ではありません。'
      }
    }
  },

  stripePayButton: {
    addPayCardText: 'カードを追加する',
    payWithCreditCardText: '支払う',
    payWithTheCreditCardText: '{cardType} {last4}で支払う',
    tooltips: {
      selectPaymentCardText: 'カードを選択する。',
      addPaymentCardText: 'カードを追加する'
    },
    cards: {
      add: {
        linkText: 'カードを追加する',
        cardNumberText: 'カード番号',
        expirationDateText: '有効期限',
        cvcText: 'CVC',
        postalCodeText: '郵便番号',
        postalCodeTextHint: '111-2345',
        addCardButtonText: 'カードを追加する',
        cancelButtonText: 'キャンセル',
        error: {
          add: '',
          token: 'すみません、カード情報が有効ではありません。'
        }
      },
      list: {
        noCardsFoundText: 'カードが見つかりません。',
        tooltips: {
          selectAsDefaultText: 'このカードを選択する。',
          removeCardText: 'このカードを削除する。'
        },
        confirmCardDelete: '本当にこのカードを削除しますか？'
      }
    }
  },

  account: {
    payment: {
      titleText: 'お支払い方法'
    },
    update: {
      titleText: 'アカウントを更新する。',
      successText: 'アカウント情報が更新されました。',
      failText: 'すみません、アカウント情報を更新できません。',
      placeholder: {
        picture: '写真',
        changePicture : '写真を変更する',
        countryCode: '国名コード',
        phoneNumber: '電話番号',
        firstName: '名前',
        lastName: '氏名',
        email: 'メールアドレス',
        referralCode: '参照コード'
      },
      saveButtonText: 'セーブする',
      cancelButtonText: 'キャンセル',
      editButtonText: '編集',
      firstName: {
        required: '名前を入力してください。'
      }
    },
    orders: {
      titleText: '注文',
      pastButtonText: '過去',
      currentButtonText: '現在',
      viewReceiptButtonText: 'レシートを見る',
      pickupText: ' {pickupDate}にピックアップする',
      rateOrderButtonText: '注文を評価する',
      reorderButtonText: '再注文する',
      noOrderFoundText: '注文はありません',
      success: {
        emailSent: 'メールが送信されました。'
      },
      error: {
        fetchOrders: 'すみません、ご注文の料理を受け取って、お渡しすることができませんでした。',
        fetchOrder: 'すみません、ご注文の料理を受け取って、お渡しすることができませんでした。',
        emailSent: 'すみません、メールが送れませんでした。',
        rating: 'Sorry, can not rate this order.' //updated
      },
      rating: {
        ratingText: '評価'
      },
      status: {
        pending: '待機中',
        accepted: '受領済み',
        preparing: '準備中',
        complete: '完了',
        paid: '完了',
        rejected: '拒否されました'
      }
    },

    rewards: {
      titleText: 'リワード',
      pointsText: 'ポイント',
      summaryText: '合計',
      earnText: '獲得',
      redeemText: '使用',
      summary: {
        all: 'すべて',
        earn: '獲得',
        redeem: '使用'
      },
      redeem: {
        viewOffersText: 'オファーを見る',
        descriptionText:
          '近くのお店で、ポイントを使って、ご飯や飲み物を手に入れよう。',
        addressBarPlaceholder: '住所を入力する'
      }
    }
  },
  orderInvite: {
    content: '{hostName} が{restaurantName}で注文しようとあなたを招待しています。',
    button: {
      accept: '一緒に注文する',
      ignore: '今回はしない'
    },
    error: {
      acceptOrderInvite: 'すみません。',
      ignoreOrderInvite: 'すみません。'
    }
  },
  orderInviteChanged: {
    content: '{hostName} が予約のお時間を変更しました。',
    button: {
      accept: 'OK',
    },
    error: {
      acceptOrderInvite: 'すみません。',
    }
  },
  join: {
    contentText: 'で注文しようとあなたを招待しています。',
    yesButtonText: 'もちろん！',
    noButtonText: 'いいえ、結構です。',
    okButtonText: 'OK',
    error: {
      tokenExpired: 'すみません、トークンが有効ではありません。',
      createOrder: 'すみません、友達の注文でエラーが起きました。'
    }
  },

  friends: {
    titleText: '友達',
    newTag: '新しいタグ',
    header: {
      friendRequests: '友達リクエスト',
      findFriends: '友達を見つける'
    },
    tooltip: {
      addTag: '新しいタグを追加する'
    },
    button: {
      search: '検索'
    },
    placeholder: {
      search: '名前かタグで友達を探す'
    },

    tabs: {
      friends: '友達',
      add: '追加',
      pending: '保留'
    },
    addFriend: {
      labelText: '友達を招待する',
      inviteesTitle: '最近招待した友達',
      placeholder: {
        phoneOrEmail: '電話かメール'
      },
      phoneOrEmailNotFound:
        'あなたの友達を ClickDishesで見つけられません。友達ClickDishesに招待しますか？',
      success: {
        friendRequestSent: '友達リクエストが送られました。'
      },
      error: {
        friendRequestSent: 'すみません、友達リクエストが送れません。',
        fetchPendingInvites: 'すみません、保留の招待を表示できません。'
      }
    },
    referFriend: {
      titleText: '友達をClickDishesに招待する',
      descriptionText:
        `ClickDishesに友達を招待すれば、あなたもお友達も2000ポイント、ゲットできます！`,
      referralCodeText: '紹介コード',
      message:
        `次のランチをClickDishesのアプリで注文しよう！\nランチのために列に並ぶのではなく、事前に注文しよう。\n私のコード '{referralCode}'でサインアップしたら、2000ポイントゲットできるよ。`,
      emailSubjectText: ':firstName があなたを ClickDishes に招待しました！'
    },
    error: {
      fetchFriends: 'エラー。友達を確認することができませんでした',
      removeTag: 'エラー。タブが削除できませんでした',
      unfriend: 'エラー。フレンド解除ができませんでした'
    }
  },

  friendRequests: {
    button: {
      accept: '承諾',
      acceptNow: '今承諾する',
      ignore: '無視する'
    },
    error: {
      fetchRequests: 'エラー。友達リクエストが受け取れませんでした',
      accept: 'エラー。友達リクエストが',
      reject: 'エラー。友達リクエストを却下できませんでした'
    }
  },

  findFriends: {
    title: '友達を見つける',
    button: {
      connect: '接続',
      remove: '解除',
      cancel: 'キャンセル',
      requestSent: 'リクエスト送信済み ',
      requestRejected: 'リクエスト却下済み',
      friend: '友達'
    },

    placeholder: {
      phoneOrEmail: '友達の電話番号かメールアドレス'
    },

    error: {
      fetchInviteList: 'エラー。招待リストが確認できませんでした',
      cancelInvite: 'エラー。招待をキャンセルできませんでした',
      sendRequest: 'エラー。友達リクエストが送れませんでした',
      findFriend: 'エラー。友達を見つけることができませんでした',
      invalidInput: '電話番号かメールアドレスが間違っています',
      notFound: '友達は見つかりません'
    }
  },

  friendDetails: {
    name: '名前',
    email: 'メールアドレス',
    displayName: 'ディスプレイネーム:',
    tags: 'タグ:',
    confirm: {
      unfriend: '本当に {friend}を友達解除しますか？'
    },
    error: {
      setDisplayName: 'エラー。ディスプレイネームを変えることができません',
      removeTag: 'エラー。タグを消すことができません'
    }
  },

  refer: {
    copied: '紹介コードをコピーしました',
    titleText: '友達を招待する',
    descriptionText:
      `友達をClickDishesに招待して、友達が新規登録したら、あなたも友達も2000ポイント獲得できます！`,
    referralCodeText: '紹介コード',
    message:
      `次のランチは列に並ばずClickDishesアプリで注文しよう ` +
      `私の紹介コード ':referralCode'で登録したら ` +
      `初回オーダーから$2オフ`,
    emailSubjectText: ':firstName があなたをClickDishesに招待しました'
  },

  inviteLink: {
    pickupForFriends: '友達のご飯も受け取りますか？',
    error: {
      serverError: 'エラー招待リンクが作れませんでした',
      signInFirst: 'まずログインしてください'
    },
    modal: {
      title: '友達を招待してリワードポイントをゲットしよう',
      menu: {
        friends: '友達',
        shareLink: 'リンクを共有'
      }
    },
    sendLink: {
      title: 'リンクを共有',
      button: 'コピー',
      copied: '招待リンクがコピーされました'
    },

    sendInvites: {
      title: {
        invites: '招待する友達',
        invited: '招待済みの友達'
      },
      placeholder: {
        search: '友達の名前かタグを入力ください'
      },
      button: '招待する',
      success: {
        sendOrderInvites: '注文への招待が送信されました'
      },
      error: {
        fetchOrderInvites: 'エラー。注文への招待が確認できませんでした',
        sendOrderInvites: 'エラー。注文への招待が送信できませんでした',
        fetchFriends: 'エラー友達を確認できませんでした'
      }
    }
  },
  joinLink: {
    error: {
      createLink: 'エラー。注文ーダーリンクが作成できませんでした'
    }
  },
  orderStatus: {
    title: {
      normalOrder: '注文',
      groupOrder: '友達のご飯やドリンクも受け取る'
    },
    confirm: {
      cancelOrder: '本当にこの注文をキャンセルしますか？',
      hostOrderCanceled:
        'ホストの注文がキャンセルされました。あなたもキャンセルしますか？もしくは一人の注文として継続しますか？',
      yesButtonText: '注文をキャンセル',
      noButtonText: '一人の注文として進める'
    },

    button: {
      acceptOrder: '注文ーを受け取る',
      rejectOrder: '注文を拒否する',
      cancelOrder: '注文をキャンセルする',
      emailReceipt: 'レシートをメールする'
    },
    success: {
      acceptOrder: 'お店が注文を受け取りました!',
      rejectOrder: 'お店が注文を拒否しました',
      cancelOrder: '注文がキャンセルされました',
      emailReceipt: 'レシートが送信されました'
    },
    error: {
      fetchOrder: 'ご注文状況を確認できません。',
      acceptOrderError: 'エラー。この注文は受理されませんでした',
      rejectOrderError: 'エラー。この注文は拒否されました',
      cancelOrder: 'エラーこの注文はキャンセルできません',
      emailReceipt: 'エラー。レシートが送信できませんでした'
    },
    step: {
      waitForRestaurantConfirm:
        'ご注文内容が送信されました。お店の承認をお待ちください。',
      orderRejected: 'ご注文内容はお店から拒否されました。',
      foodPrepared: 'ご注文内容は準備中です。',
      pickup:
        'ご注文内容が準備できました。お店へ向かい、このコード ({shortCode})をピックアップカウンターに提示ください'
    },
    guestStep: {
      waitForHost: '注文を送信済み。お店が注文を受理するのを',
      foodPrepared: '注文内容を準備中です...',
      pickup: '注文内容の準備ができました {host} が受け取ってもってきます'
    }
  },
  verifyEmail: {
    spinner: 'メールアドレスの認証 ... ',
    error: {
      invalidCodeOrEmail: 'メールアドレスかコードが間違っています'
    },
    success: {
      verified: 'メールアドレスが認証されました！'
    }
  },

  info: {
    titleText: '情報'
  },

  feedback: {
    placeholder: 'ご意見下さい',
    button: {
      send: '送信',
      cancel: 'キャンセル'
    },
    success: 'ご意見受信しました。有難うございます。',
    error: 'フィードバックの'
  },
 PRICE: '{price, number, currency}' 
};
